import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './GlobalStyle';
import theme from './theme';

const CustomThemeProvider = (props: {children: ReactNode}) => {
	return(
		<ThemeProvider theme={theme}>
			<GlobalStyle/>
			{props.children}
		</ThemeProvider>
	);
};

export default CustomThemeProvider;